export const selectEmployeeProfile = state => state.employeeProfile?.data || {};

export const selectEmployeeActivateProfile = state => state.employeeProfile?.activate || {};
export const selectIsEmployeeProfile = state => !!selectEmployeeProfile(state).workdayId;
